<template>
<div>
<spinner v-bind:spinner='spinner'></spinner>

<product-info v-bind:productId="productId"></product-info>


<h4>MODIFICA VARIANTI ARTICOLO</h4>
<div class="table-responsive">              
<table class="table table-bordered table-sm" id="updateProduct">
<thead class="thead-light">
    <tr>

  <th 
          class = "text-center"
           v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
          v-for="(col,index) in cols" :key="index">
          
            <span v-bind:style="{ color: col!='colore' ? 'black':'blue' }">{{col}}</span>
          </th>

   
    </tr>
</thead>
<tbody>
    <tr v-for="(item, index1) in rows" :key="index1">
        <td v-for="(col,index2) in cols" :key="index2" >
            <span style="color:#191970" v-if = "col=='colore'"><strong>{{item[col]}}</strong></span>
            <!--<small v-if = "col=='colore'" style="color:#ff5706" id="supplierColor" class="form-text ">{{item['supplierColor']}}</small>-->
            <div style='color : red' v-if="col=='colore'">
              <label for="colore" class="form-label"><strong>{{item.supplierColor}}</strong></label>
              <!--<input v-model="item.supplierColor" class="form-control inputClass" type="text" :placeholder="'colore fornitore'">-->
            </div> 
            <input v-else  v-focus :ref="'id_'+  index1 + index2" :id="'id_'+index1+index2"   v-on:keydown="keyHandler" v-model.number="item[col]['qty']"  class="form-control inputClass" type="number"  :placeholder="''" >
        </td>
    </tr>
</tbody>
</table>
<!-- Table -->
</div>

  
  <alert-box class="mt-1 mb-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <button :hidden="bt_hidden" @click="submit()"  class="btn btn-primary mt-2 float-right">
    <i  class="fas fa-edit mr-2" aria-hidden="true"></i>
    SALVA</button>
  
  <button @click="$emit('close')"  class="btn btn-outline-secondary float-left mt-2">CHIUDI</button>
  <!--<button @click="resetQty()" style='margin-top:10px;margin-left:15px' class="btn btn-outline-danger float-left">Azzera varianti</button>-->
  



</div> 
</template>

<script>


import api from '@/api'
import _ from "lodash";

import spinner             from '@/components/common/Spinner.vue';

import ProductInfo         from '@/components/product/ProductInfo.vue';
import alertBox            from '@/components/common/AlertBox.vue';
import {eanCD,createEAN13} from '@/functions';
import syncStock           from '@/components/mixins/SyncStock.js' 

export default {
    props :['storeId','movementId','productId','movementType'],
    components: {ProductInfo,spinner,alertBox,
    
  },
  mixins : [syncStock]  
  ,
  data () {
    return {      
      spinner       : false,
      total         : 0,
      cols          : [], 
      rows          : [],
      dataItems     : [],
      colors        : [],
      counter       : 0,
      priceCost     : [],
      priceRetail   : [], 
      discount      : 0,
      vat           : 0,

      
      
      msg           : {
        title : '',
        body  : '',
        type  : 0
      },
    

      productColors : [],
      sizeList      : [],
      file          : '',
      barcodeList   : [],
      bt_hidden     : false
       
    }
  },
  computed: 
  {   
     //...mapGetters(['shipping']),
    
     
  },
  directives: {
  focus: {
    // directive definition
    inserted: function (el) {
      
      if(el.id=='id_01')
      {
        el.focus()
      }
    }
  }
},
  mounted()
  {
    
  },
  async created()
  {
    const data      = {'productId' : this.productId,'movementId':this.movementId} 
    const sp        = {'sp':'spProductMovement'}
    this.spinner  = true
    const json      = Object.assign(data, sp);

    await api.post(json).then(res => {
      if(res.status==200)
        {
            var item        = res.data.recordsets
           

           this.dataItems   = item[0]
           this.priceCost   = item[3]
           this.priceRetail = item[2]
           this.discount    = item[0][0]['discount'] 
           this.vat         = item[0][0]['vat'] 
           this.counter     = item[1][0].counter
            
            // product sizes movement
            this.sizeList =  _.uniqBy(
            _.map(item[0], function(object) {
              return _.pick(object, ['size','sizeId']);
            }),"sizeId"
          );  

          // product colors movement
          this.productColors =  _.uniqBy(
            _.map(item[0], function(object) {
              return _.pick(object, ['colorId','productColor','supplierColor','newColor']);
            }),"colorId"
          );  
          
          this.barcodeList = item[4]
          this.createGrid(this.sizeList,this.productColors)
                   
                 
        }
        else if(res.status==500)
        {
          console.log(res.data)

        } 
        else
        {
          console.log('Network Error.')                  
        } 
    }).catch(err => 
    {
      console.log(err.message)    
    }).finally(() => {
      this.spinner = false
    });

    
 
  },
  watch: 
  {

    'items' : 
    {
      deep: true,  

      handler : function(newValue) 
      {                
      
      }
            
    }
  },
      
  mounted()
  {
   
    
  },
  methods: 
  {
   
    resetQty()
    {
      this.rows.forEach(item=>{
        this.cols.forEach(col=>{
          
          if(col!='colore')
          {
       
            item[col].qty = 0
          }
        })
       
      })
    },
    
    createGrid(sizes,colors)
    {
      

      var priceCost = []
      var priceRetail = []
      
      this.cols = []
      this.cols.push('colore') 
      var productId = this.productId

      sizes.forEach(item => {
            
            this.cols.push(item.size)

            })
            
          
        
          var arr = []
          var obj = {}
          var tmp = {}

          colors.forEach(color=>{

            obj  = {}
            obj.colore        = color.productColor
            obj.supplierColor = color.supplierColor           
            sizes.forEach(size => {
              
              // check item presente su questo Movimento
              var item          = this.dataItems.filter(item => (item.colorId == color.colorId && item.sizeId == size.sizeId))                           

              // check esistenza barcode da altri movimenti
              if(item.length == 0)
              {
                item = this.barcodeList.filter(item => (item.colorId == color.colorId && item.sizeId == size.sizeId)) 
              } 
              
              tmp               = {}

              priceCost = this.priceCost.filter(el => el.sizeId === size.sizeId)
              priceRetail = this.priceRetail.filter(el => el.sizeId === size.sizeId)
              
              if(item.length==0)
              {

                this.counter ++   
                tmp['id']              = 0 
                tmp['qty']             = 0
                tmp['savedQty']        = 0
                tmp['barcode']         = createEAN13(productId,this.counter)

              }
              else
              {
                tmp['id']              = item[0].id  == undefined ? -1 : item[0].id
                tmp['qty']             = item[0].qty == undefined ? 0 : item[0].qty
                tmp['savedQty']        = item[0].qty == undefined ? 0 : item[0].qty
                tmp['barcode']         = item[0].barcode
              
              }
              

              tmp['productId']       = productId
              tmp['costPrice']       = priceCost[0]['price']
              tmp['retailPrice']     = priceRetail[0]['price']
              tmp['vat']             = this.vat
              tmp['discount']        = this.discount
              tmp['colorId']         = color.colorId
              tmp['sizeId']          = size.sizeId
              tmp['supplierColor']   = color.supplierColor
                              
              obj[size.size] = tmp 
              

            })

             arr.push(obj)


          })
         
        
        this.rows = arr 
   

    },

    async submit()
    {
    
      let items = []
      let obj   = {}
      let check = 0
      
      for(var i = 0; i < this.rows.length; i++) 
          {
            var row = this.rows[i];
            Object.entries(row).forEach(entry => 
            {
              let key = entry[0];
              let item = entry[1];
              obj = {}
              //console.log('row ',row)
              if(key !='colore' && key != 'supplierColor')
              {
                check                 = check + item.qty   
                obj['productId']      = item.productId
                obj['id']             = item.id 
                obj['barcode']        = item.barcode
                
                obj['costPrice']      = item.costPrice
                obj['retailPrice']    = item.retailPrice
                obj['discount']       = item.discount
                obj['vat']            = item.vat
                obj['qty']            = item.qty
                obj['colorId']        = item.colorId
                obj['sizeId']         = item.sizeId
                obj['qty']            = item.qty 
                obj['supplierColor']  = item.supplierColor

                // riga stock esistente
                if(item.id > 0 && item.qty != item.savedQty)
                {
                  obj['qty']            = item.qty - item.savedQty
                  items.push(obj)
                }
                // riga stock nuova qty > 0
                if(item.id <= 0 && item.qty > 0)
                {
                  items.push(obj)
                }  
                  

              }        
            });  
          }
         
         //console.log('Items Modifica Movimento',items)
       
        var data    = {}
        data.header = {}
     
        // NESSUNA MODIFICA
        if(items.length == 0)
        {
          
          return
          
        }
              

        data.header.movementId  = this.movementId
      
        data.header.storeId     = this.storeId        
        data.header.productId   = this.productId
        data.header.counter     = this.counter
        data.header.movementType = this.movementType
        data.body               = items
        
        const sp    = {'sp':'spUpdateMovementProduct'}
        const json  = Object.assign(data, sp);
        
        this.bt_hidden = true
        this.spinner = true
        
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.msg.title = 'MODIFICA EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0   
             
              
              /* SYNC STOCK */
              this.syncStock(this.movementId)     
              
              
                 
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1        

            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res
              this.msg.type  = 1        

            } 
        }).catch(err => 
        {
          

          this.msg.title = 'ATTENZIONE '
          this.msg.body  = err.message
          this.msg.type  = 1        

        }).finally(() => {
          this.spinner = false
        });



        


    },



    keyHandler: function(event) 
    {
      
      if(event.keyCode==109)
      {
        event.preventDefault()
      }
      if(event.keyCode==107)
      {
        event.preventDefault()
      }
      if(event.keyCode==188)
      {
        event.preventDefault()
      }
     
        
    },
    createItems: function()
    {
        
      
    },
      

    }
  
}
</script>

<style scoped>
.inputClass{
  font-weight       : bold;
  
  }
.misura
{
  color        : coral;
  font-size    : 12px;
}

input[type=text]:disabled {
  background : white;
  color      : navy
}
h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 18px;
}
p {
  font-family  : 'Roboto Condensed';
  font-size    : 25px;
}
span {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
#deleteBox .modal-footer {  
  justify-content: space-between;  
}

</style>